export const EExchangeImplementationType = {
  "0": "UNKNOWN",
  "1": "COMMERZBANK",
  "2": "FIXER",
  "-1": "ALL"
};